export const iconFontAwesomeReligionYinYang = (
	<i className="fa-solid fa-yin-yang"></i>
);
